import $ from 'jquery';
import Animation from 'modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaPlankton',
			dom: {
				slides: '.js-plankton-slides',
				slide: '.js-plankton-slide',
				submit: '.js-plankton-submit',
				form: '.js-plankton-form'
			},
			classes: {
				slide: {
					slide: 'b-plankton__slide',
					active: 'b-plankton__slide_state_active'
				}
			},
			timeout: 4000
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$slides = this.$el.find(this.options.dom.slides);
		this.$slide = this.$el.find(this.options.dom.slide);
		this.$submit = this.$el.find(this.options.dom.submit);
		this.$form = this.$el.find(this.options.dom.form);
		return this;
	}

	onSubmit(e) {
		const self = this;
		e.preventDefault();
		$.ajax({
			url: self.$form.attr('action'),
			type: self.$form.attr('method'),
			data: self.$form.serialize(),
			dataType: 'json',
			success: function (json) {
				if (json.success) {
					if (json.location) {
						window.location.href = json.location;
					}
				} else {
					$(() => new Animation({el: self.$form}).play('shake'));
				}
			}
		});
	}

	startShow() {
		const self = this;
		this.show = setInterval(function () {
			const $activeSlide = self.$slide.filter('.' + self.options.classes.slide.active);
			const $nextSlide = $activeSlide.next('.' + self.options.classes.slide.slide);
			self.$slide.removeClass(self.options.classes.slide.active);

			if ($nextSlide.hasClass(self.options.classes.slide.slide)) {
				$nextSlide.addClass(self.options.classes.slide.active);
			} else {
				self.$slide.first().addClass(self.options.classes.slide.active);
			}
		}, self.options.timeout);
	}


	render() {
		if (this.$el.length) {
			this.getDom();
			this.startShow();
			this.$submit.on('click', this.onSubmit.bind(this));
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/plankton/plankton.js